import iconPath from '@/assets/device-icons/imac-2020.svg';

interface Imac2020IconProps {
  className?: string;
}

export const Imac2020Icon = ({ className = "h-5 w-5" }: Imac2020IconProps) => {
  return (
    <img 
      src={iconPath} 
      alt="iMac 2020" 
      className={className}
    />
  );
};
